import { extend } from '../../util/jquery';
import { marketsTimeSeriesTransform } from '../transforms/markets/time-series';

export default class TimeSeries {
    constructor(options) {
        this.securityManager = options.securityManager;
        this.apiManager = options.apiManager;
    }

    async timeSeries({
        query,
        preAfter,
        tradingDays,
        frequency,
        startDate,
        endDate,
        endOfLastWeekOrMonth
    }) {
        if (!query || !frequency) {
            throw new Error('Missing required parameters query or frequency');
        }
        let securities = new Set();
        query.forEach(q => {
            const symbols = q.split(':')[0];
            symbols.split(',').forEach(s => {
                if (!/^CU\$\$\$\$\$.+/.test(s)) {
                    securities.add(s);
                }
            });
        });
        const params = {
            query,
            frequency
        };
        if (!isNaN(frequency)) {
            params.preAfter = preAfter;
        }
        if (tradingDays) {
            params.tradingDays = tradingDays;
        } else {
            params.startDate = startDate;
            params.endDate = endDate ? endDate : 'now';
        }
        if (endOfLastWeekOrMonth && (frequency === 'w' || frequency === 'm')) {
            params.endOfLastWeekOrMonth = true;
        }
        securities = Array.from(securities);
        return Promise.all([
            this.apiManager.timeSeries(params),
            this.securityManager.create(securities)
        ]).then(res => {
            const data = res[0].map(d => {
                const security = this.securityManager.getSecurities([
                    d.queryKey
                ]);
                if (security.length) {
                    const {
                        marketCloseTime,
                        marketOpenTime,
                        marketPreOpenTime,
                        marketPostTradingCloseTime,
                        IPODate
                    } = security[0];
                    d.ticker = extend(true, {}, d.ticker, {
                        marketCloseTime,
                        marketOpenTime,
                        marketPreOpenTime,
                        marketPostTradingCloseTime,
                        IPODate
                    });
                }
                return d;
            });
            return marketsTimeSeriesTransform(data, params);
        });
    }

    async exportData({ fileName, summary, sheets }) {
        if (!fileName || !sheets) {
            throw new Error('Missing required parameters fileName or sheets');
        }
        const data = {
            fileName,
            sheets
        };
        if (summary) {
            data.summary = summary;
        }
        return this.apiManager.exportData({
            data
        });
    }
}
